import { useRouter } from 'vue-router'
import Stores from '@/stores/Stores'
import StoreUtil from '@/stores/StoreUtil'

/**
 * コンポーネントマウント時に、引数で指定したストアのプロパティの状態をチェックし、
 * 空のプロパティがある場合には指定したパスに遷移する
 * @param storeName チェックするストアの名前
 * @param propertyNames チェックするストアのプロパティ
 * @param replaceName チェックしたプロパティが空の場合に遷移するrouteの名前
 */
export default async function useValidateForAccess<T extends keyof typeof Stores>(
  storeName: T,
  propertyNames: (keyof typeof Stores[T])[],
  replaceName: string,
) {
  const store = StoreUtil.useStore(storeName)
  StoreUtil.useStore('ErrorStore').setConfig('directAccessError')
  const isValid = propertyNames.every(propertyName => !!store[propertyName])
  if (!isValid) {
    const router = useRouter()
    router.replace({ name: replaceName })
  }
}
